import Bottom from './Bottom';
import Contacts from './Contacts';
import InformationLinks from './InformationLinks';
import NewsletterSignUp from './NewletterSignUp';
import Socials from './Socials';

const Footer = () => {
  return (
    <div className="mt-0 bg-teal-500 px-[5%] pt-14 text-white sm:mt-16">
      <div className="grid grid-cols-1 flex-col-reverse gap-6 lg:grid-cols-2">
        <InformationLinks />
        <div className="order-1 grid grid-cols-1 gap-6 md:grid-cols-2">
          <div className="order-2 lg:order-none">
            <Contacts />
            <Socials />
          </div>
          <NewsletterSignUp />
        </div>
      </div>
      <Bottom />
    </div>
  );
};

export default Footer;
